export function resolveCheckoutIdentity({
  authToken,
  sessionProspectToken,
  prospectTokenOverride,
}: {
  authToken?: string | null
  sessionProspectToken?: string | null
  prospectTokenOverride?: string | null
}): { authToken?: string | null; prospectToken?: string | null } {
  if (authToken) {
    return { authToken, prospectToken: null }
  }

  return {
    authToken: null,
    prospectToken: prospectTokenOverride ?? sessionProspectToken ?? null,
  }
}
